import { ATTRIBUTE_WHITE_LIST, HS_PROTECT } from '../constants/xss-protect';
const toCamelCase = string => string.replace(/-([a-z])/g, g => g[1].toUpperCase());
const toKabob = string => string.replace(/([a-z][A-Z])/g, g => `${g[0]}-${g[1].toLowerCase()}`);
const dummyNode = document.createElement('div');

// Returns the trailing data component of the data URL
export const parseDataUrl = url => {
  const match = url.match(/^data:([a-z]+\/[a-z0-9-+.]+(;[a-z0-9-.!#$%*+.{}|~`]+=[a-z0-9-.!#$%*+.{}()|~`]+)*)?;base64,([a-zA-Z0-9!$&',()*+;=\-._~:@/?%\s<>]*?)$/);
  if (match && match[3]) {
    return match[3];
  }
  return null;
};

// The use of SET here is OK because we only use the `has` method
// which has the browser support we need
const attributeSet = new Set(ATTRIBUTE_WHITE_LIST);
export const xssTransformIn = (body, retainAttribute = true) => {
  const nodes = Array.from(body.querySelectorAll('*'));
  const dataRegex = /^([a-zA-Z0-9-_]+)?data([a-zA-Z0-9-_]+)?$/;
  const validAttributeNameRegex = /^[a-zA-Z_:][a-zA-Z0-9:._-]*$/;
  nodes.forEach(node => {
    const attrs = Array.from(node.attributes);
    for (let i = 0; i < attrs.length; i++) {
      const attrName = attrs[i].name;
      const attrValue = attrs[i].value;
      let shouldProtect = !attributeSet.has(attrName) && !dataRegex.test(attrName);
      const shouldRemove = !validAttributeNameRegex.test(attrName);
      if (node.nodeName === 'IFRAME' && attrName === 'src') {
        if (attrValue.indexOf('script') >= 0) {
          shouldProtect = true;
        } else {
          const base64Url = parseDataUrl(attrValue);
          if (base64Url) {
            // Decode any base64 encodings and protect against script tags
            let decodedSrc;
            try {
              decodedSrc = atob(encodeURI(base64Url));
              shouldProtect = decodedSrc.indexOf('script') >= 0;
            } catch (e) {
              console.info(`${HS_PROTECT}: ${attrName} is not a valid data URL.`);
              node.removeAttribute(attrName);
              console.log(e);
            }
          }
        }
      }
      if (shouldRemove) {
        node.removeAttribute(attrName);
        console.info('Removing invalid attribute: ', attrName);
      } else if (shouldProtect) {
        try {
          dummyNode.setAttribute(attrName, attrValue);
        } catch (e) {
          console.info(`${HS_PROTECT}: ${attrName} is not a valid attribute, removing.`);
          node.removeAttribute(attrName);
          console.error(e);
          continue;
        }
        try {
          if (retainAttribute) {
            node.dataset[`${HS_PROTECT}${toCamelCase(attrName)}`] = attrValue;
          }
          node.removeAttribute(attrName);
        } catch (e) {
          console.info(`${HS_PROTECT}: Failed to set ${attrName} on element dataset`);
          console.error(e);
        }
      }
    }
  });
};
export const xssTransformOut = body => {
  const nodes = Array.from(body.querySelectorAll('*'));
  nodes.forEach(node => {
    const dataset = node.dataset;
    Object.keys(dataset).forEach(dataKey => {
      if (dataKey.startsWith(HS_PROTECT)) {
        const value = dataset[dataKey] || String(dataset[dataKey]);
        const dataAttribute = toKabob(dataKey.replace(HS_PROTECT, ''));
        if (dataAttribute !== '') {
          node.setAttribute(dataAttribute, value);
        }
        delete dataset[dataKey];
      }
    });
  });
};